import {TweenLite} from 'gsap';
import throttle from 'lodash/throttle';

export default class Cursor {
  constructor(cursor, cursorWidth) {
    this.cursor = document.querySelector(cursor);
    this.cursorWidth = cursorWidth;
    this.angles = { start: 0, end: 0 }

    this.setCursorPosition = this.setCursorPosition.bind(this);
    this.drawCircle = this.drawCircle.bind(this);

    this.initialize();
  }

  initialize() {
    addEventListener('mousemove', this.setCursorPosition);
    addEventListener('scroll', throttle(this.drawCircle, 100));
  }

  setCursorPosition(event) {
    TweenLite.to(this.cursor, 0.75, {
      left: event.clientX - (this.cursorWidth / 2),
      top: event.clientY - (this.cursorWidth / 2),
    });
  }

  getScrollPercent() {
    if (window.pageYOffset > 0) {
      return (window.pageYOffset / this.getPageHight()) * 100;
    } else {
      return 0;
    }
  }

  getPageHight() {
    return document.documentElement.scrollHeight - document.documentElement.clientHeight;
  }

  drawCircle() {
    let percent = this.getScrollPercent();
    let centerPos = this.cursorWidth / 2;

    let ctx = this.cursor.querySelector('canvas').getContext('2d');

    ctx.strokeStyle = 'white';
    ctx.lineWidth = 1;

    TweenLite.to(this.angles, 0.5, {
      end: 360 * (percent / 100),
      onUpdate: () => {
        ctx.clearRect(0, 0, this.cursorWidth, this.cursorWidth);
        ctx.beginPath();
        ctx.arc( centerPos, centerPos, centerPos - (ctx.lineWidth * 2), this.angles.start * Math.PI / 180, this.angles.end * Math.PI / 180, false );
        ctx.stroke();
      }
    });
  }
}
